module.exports = __webpack_public_path__ + "assets/img/block-left-cd37b0a1.png";